import * as React from "react";
import * as ReactCSSTransitionReplace from "react-css-transition-replace";
import {isEdge, isIE, isMobile} from "react-device-detect";
import {connect} from "react-redux";
import {IBackgroundComponent} from "src/ScrollyInterface";
import {setStyles} from "../shared/breakpoints";
import {IStateApp} from "../store/StoreInterface";

const bkg = (props: IBackgroundComponent) => {
	const {
		breakpoint,
		content,
		mediaLoaded,
		muted,
		onMediaLoaded,
		onVideoLoaded,
		videoLoaded
	} = props;

	const handleSpinner = () => {
		let timeout: number | undefined;
		clearTimeout(timeout);
		if (content.id === 0 && !mediaLoaded) {
			timeout = window.setTimeout(() => {
				onMediaLoaded(true);
			}, 1800);
		}
	};

	const handleVideoLoaded = () => {
		if (isIE) {
			onVideoLoaded(true);
		}
	};

	const setBackground = () => {
		let url = "";
		let background;

		const styleImgContainer = {
			height: "100%",
			position: "fixed" as "fixed",
			top: 0,
			width: "100%",
			zIndex: -5
		};

		const styleImg = {
			backgroundImage: `url('${content.link ? content.link.src : ""}')`,
			backgroundPosition: "center center",
			backgroundRepeat: "no-repeat",
			backgroundSize: "cover",
			height: "100%",
			left: 0,
			objectPosition: isMobile ? content.background_position : "",
			overflow: "hidden",
			position: "fixed" as "fixed",
			top: 0,
			width: "100%"
		};

		const styleVideoContainer = {
			backgroundPosition: "center center",
			backgroundRepeat: "no-repeat",
			backgroundSize: "cover",
			height: "100%",
			left: 0,
			overflow: "hidden",
			position: "fixed" as "fixed",
			top: 0,
			width: "100%",
			zIndex: -5
		};

		const styleVideo =
			isIE || isEdge
				? {
					height: "auto",
					left: "50%",
					minHeight: "100%",
					minWidth: "100%",
					position: "fixed" as "fixed",
					top: "50%",
					transform: "translate(-50%, -50%)",
					width: "auto"
				}
				: {
					height: "100%",
					minHeight: "100%",
					minWidth: "100%",
					objectFit: "cover" as "cover",
					objectPosition: isMobile ? content.background_position : "",
					width: "100%"
				};

		const styleIE = isIE
			? {
				opacity: videoLoaded ? 1 : 0,
				transition: "opacity 0.3s ease-in"
			}
			: {};

		const posterVideo = isIE ? (
			<img
				src={content.poster}
				style={{...styleVideo, ...{zIndex: -100}}}
			/>
		) : null;

		switch (content.type) {
			case "picture":
				background = (
					<div key={content.id}>
						<div style={styleImgContainer}>
							<div style={styleImg}/>
							<img
								src={content.link ? content.link.src : ""}
								onLoad={handleSpinner}
								style={{display: "none"}}
							/>
						</div>
					</div>
				);
				break;
			case "video":

				url = `${content.link ? content.link.mp4 : ""}`;
				if(content.linkMobile) {
					url = setStyles(
						{
							default: `${content.link ? content.link.mp4 : ""}`,
							desktopMd: `${content.link ? content.link.mp4 : ""}`,
							mobileMd: `${content.link ? content.linkMobile.mp4 : ""}`,
							mobileSm: `${content.link ? content.linkMobile.mp4 : ""}`
						},
						breakpoint
					);
				}

				background = (
					<div id={`video-${content.id}`} key={content.id} style={isIE ? styleVideoContainer : {}}>
						<div style={isIE ? {} : styleVideoContainer}>
							<video
								key={url}
								loop={true}
								muted={muted}
								autoPlay={true}
								onCanPlay={handleSpinner}
								onCanPlayThrough={handleVideoLoaded}
								playsInline={true}
								poster={isIE ? content.poster : ""}
								preload="auto"
								style={{...styleVideo, ...styleIE}}
							>
								<source
									src={url}
									type="video/mp4"
								/>
								<source
									src={content.link ? content.link.ogv : ""}
									type="video/ogg"
								/>
								<source
									src={content.link ? content.link.webm : ""}
									type="video/webm"
								/>
								Your browser does not support the video tag.
							</video>
							{posterVideo}
						</div>
					</div>
				);
				break;
			default:
				break;
		}
		return background;
	};

	const bkground = (
		<ReactCSSTransitionReplace
			transitionName="cross-fade"
			transitionEnterTimeout={1000}
			transitionLeaveTimeout={1000}
			overflowHidden={false}
		>
			{setBackground()}
		</ReactCSSTransitionReplace>
	);

	return bkground;
};

const mapStateToProps = (state: IStateApp) => {
	return {
		breakpoint: state.ui.breakpoint
	};
};

export default connect(
	mapStateToProps,
	null
)(bkg);


// export default bkg;



// WEBPACK FOOTER //
// ./src/components/BackgroundComponent.tsx